var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("INESC TEC - All Rights Reserved 2025")])}
var staticRenderFns = []

export { render, staticRenderFns }